import React, { useCallback } from 'react';
import { GridContainer } from './ChartWrapper.styles';
import ScatterPlot from './ChartList/ScatterPlot';
import StackedBar from './ChartList/StackedBar';
import BoxPlot from './ChartList/BoxPlot';
import BLSCity from './ChartList/BLSCity';
import BLSMsa from './ChartList/BLSMsa';
import { useChartContext } from 'contexts/CategoryChartContext';
import PieChart from './ChartList/PieChart';
import HeatMap from './ChartList/HeatMap';
import SplineColumnChart from './ChartList/SplineColumnChart';

const ChartsWrapper = ({ chartsOption, currentTab }) => {
	const { state } = useChartContext();

	const {
		scatterPlotData,
		blsStateChartData,
		blsStateDrilldownData,
		blsCityChartData,
		markupChartData,
		markupCategories,
		markupSuppliers,
		boxPlotClientData,
		boxPlotData,
		spendBreakdownData,
		spendByPaycodeData,
		topStatesData,
		avgMarginBySupplierData,
		avgMarginGrossSpendData,
		avgMarginByJobTitleData,
	} = state;
	const getChart = useCallback(
		(accumulator, data) => {
			if (data.show && data.key === 0) {
				return (
					<>
						{accumulator}
						<ScatterPlot
							key={data.key}
							chartTitle={data.title}
							isParent={true}
							chartheight={'60%'}
							chartData={scatterPlotData}
						/>
					</>
				);
			}
			if (data.show && data.key === 1) {
				return (
					<>
						{accumulator}
						<StackedBar
							chartTitle={data.title}
							isParent={true}
							data={markupChartData}
							categories={markupCategories}
							suppliers={markupSuppliers}
						/>
					</>
				);
			}
			if (data.show && data.key === 2) {
				return (
					<>
						{accumulator}
						<BoxPlot
							chartTitle={data.title}
							isParent={true}
							chartheight={'60%'}
							xLabel={data.xLabel}
							yLabel={data.yLabel}
							chartDataBoxPlotData={boxPlotClientData.boxplotData}
							chartDataScatterPlotData={boxPlotClientData.scatterData}
							xaxis={boxPlotClientData.xaxis}
							client
							boxplotSeriesName={data.boxplotSeriesName}
							scatterPlotSeriesName={data.scatterPlotSeriesName}
						/>
					</>
				);
			}
			if (data.show && data.key === 3) {
				return (
					<>
						{accumulator}
						<BLSCity
							chartTitle={data.title}
							isParent={true}
							chartheight={'60%'}
							chartData={blsCityChartData}
						/>
					</>
				);
			}
			if (data.show && data.key === 4) {
				return (
					<>
						{accumulator}
						<BLSMsa
							chartTitle={data.title}
							chartheight={'60%'}
							isParent={true}
							chartData={blsStateChartData}
							blsStateDrilldownData={blsStateDrilldownData}
						/>
					</>
				);
			}
			if (data.show && data.key === 5) {
				return (
					<>
						{accumulator}
						<>
							<BoxPlot
								chartTitle={data.title}
								isParent={true}
								chartheight={'60%'}
								xLabel={data.xLabel}
								yLabel={data.yLabel}
								chartDataBoxPlotData={boxPlotData.boxplotData}
								chartDataScatterPlotData={boxPlotData.scatterData}
								xaxis={boxPlotData.xaxis}
								client={false}
								boxplotSeriesName={data.boxplotSeriesName}
								scatterPlotSeriesName={data.scatterPlotSeriesName}
							/>
						</>
					</>
				);
			}
			if (data.show && data.key === 6) {
				return (
					<>
						{accumulator}
						<PieChart
							chartTitle={data.title}
							isParent={true}
							chartheight={'60%'}
							chartData={spendBreakdownData}
							ifFirst={true}
						/>
					</>
				);
			}
			if (data.show && data.key === 7) {
				return (
					<>
						{accumulator}
						<>
							<PieChart
								chartTitle={data.title}
								isParent={true}
								chartheight={'60%'}
								chartData={spendByPaycodeData}
							/>
						</>
					</>
				);
			}
			if (data.show && data.key === 8) {
				return (
					<>
						{accumulator}
						<HeatMap
							chartTitle={data.title}
							isParent={true}
							chartheight={'60%'}
							chartData={topStatesData}
						/>
					</>
				);
			}
			if (data.show && data.key === 9) {
				return (
					<>
						{accumulator}
						<SplineColumnChart
							chartTitle={data.title}
							isParent={true}
							chartheight={'60%'}
							chartData={avgMarginBySupplierData}
						/>
					</>
				);
			}
			if (data.show && data.key === 10) {
				return (
					<>
						{accumulator}
						<SplineColumnChart
							chartTitle={data.title}
							isParent={true}
							chartheight={'60%'}
							chartData={avgMarginGrossSpendData}
						/>
					</>
				);
			}
			if (data.show && data.key === 11) {
				return (
					<>
						{accumulator}
						<>
							<SplineColumnChart
								chartTitle={data.title}
								isParent={true}
								chartheight={'60%'}
								chartData={avgMarginByJobTitleData}
							/>
						</>
					</>
				);
			}
			return accumulator;
		},

		[state]
	);

	return (
		<GridContainer>
			{currentTab === 0
				? chartsOption.reduce(getChart, null)
				: chartsOption.reduce(getChart, null)}
		</GridContainer>
	);
};

export default React.memo(ChartsWrapper);
